import Locations from './model/locations';
const debug = require('debug')('app:admin');

const getEnvVariable = (key, defaultValue) => {
  // Ensure that process.env[key] is not only defined but also not empty
  return process.env[key] !== undefined ? process.env[key] : defaultValue;
};

const Admin = () => {
  // options: 0: Path, 3: City, 2: Road, 1: Party
  const startLocation = parseInt(getEnvVariable('REACT_APP_START_LOCATION', Locations.Path.index), 10);
  const startPhase = parseInt(getEnvVariable('REACT_APP_START_PHASE', 0), 10); // options: 0 -> path, 1 -> city, 2 -> Road, 3
  const storyInitial = getEnvVariable('REACT_APP_STORY_INITIAL', 'idle'); //'StrangerWatches';
  const speed = parseInt(getEnvVariable('REACT_APP_SPEED', 1), 10);
  const canReset = Boolean(getEnvVariable('REACT_APP_CAN_RESET', false));
  const continueCooldown = parseInt(getEnvVariable('REACT_APP_CONTINUE_COOLDOWN', 10));
  const cooldown = getEnvVariable('REACT_APP_COOLDOWN', null);
  const gracePeriod = parseInt(getEnvVariable('REACT_APP_GRACE_PERIOD', 30));
  const resources = JSON.parse(getEnvVariable('REACT_APP_START_RESOURCES', '{}'), 10);

  const phaseOne = (party, machine) => {
    for (let i = 0; i <= 12; i++) {
      machine.send({ type: 'WALK', context: { party }, result: {} });
    }
    machine.send({
      type: 'WALK',
      context: { party },
      result: { success: true }
    });
    machine.send({
      type: 'TAKE_BOWL',
      context: { party },
      result: { success: true }
    });

    party.history.delta({ firstTown: true }, null);
    party.history.delta({ roadMap: 0 }, null);
    party.history.delta({ bowl: true }, null);
    party.phases.disableAction('Walk');
    console.log(party.phases, party.city);
  };

  const phaseTwo = (party, service) => {
    phaseOne(party, service);
    // Phase two wants a town already past its story, so the one-shot goes. Phase one keeps it:
    // Examine Map is the first beat of the town sequence and the only way to the barkeep, who
    // is what opens the trade post — dropping it there would strand the fast-forward short of
    // the shop, the horse and Depart.
    party.phases.disableCityAction('ExamineMap');
    service.send({ type: 'TAKE_BOWL', context: { party } });
    service.send({ type: 'ENABLE_HEAL', context: { party } });
    service.send({ type: 'ENABLE_ROB', context: { party } });
    service.send({ type: 'ENABLE_WORK', context: { party } });
    service.send({ type: 'ENABLE_SHOP', context: { party } });
    service.send({ type: 'GET_HORSE', context: { party } });

    party.resources.attribs.food.value = resources.food || 600;
    party.resources.attribs.water.value = resources.water || 400;
    party.resources.attribs.ammo.value = resources.ammo || 1;
    party.resources.attribs.coins.value = resources.coins || 1000;
  };

  const initPhase = (party, machine, context) => {
    debug('initPhase', startPhase, context, party, machine);
    switch (startPhase) {
      case 1:
        phaseOne(party, machine, context);
        break;
      case 2:
        phaseTwo(party, machine, context);
        break;
      default:
        console.log(resources);
        party.resources.attribs.health.value = parseInt(resources.health, 10) || 5;
        party.resources.attribs.food.value = parseInt(resources.food, 10) || 0;
        party.resources.attribs.water.value = parseInt(resources.water, 10) || 0;
        party.resources.attribs.ammo.value = parseInt(resources.ammo, 10) || 0;
        party.resources.attribs.coins.value = parseInt(resources.coins, 10) || 0;
        break;
    }
  };

  return {
    initPhase,
    startPhase,
    startLocation,
    storyInitial,
    speed,
    canReset,
    continueCooldown,
    gracePeriod,
    cooldown
  };
};

export default Admin;
